<div class="unitFrame">
  <span
    >{{ unitType
    }}{{ originalValue != undefined ? " (" + originalValue + ")" : "" }}</span
  >
  <div class="btnContainer">
    <div
      class="minus-btn"
      (click)="decrementControl()"
      [class.disabled]="isDisabled"
    >
      |
    </div>
    <input type="number" inputmode="numeric" [formControl]="inputControl" />
    <div
      class="add-btn"
      (click)="incrementControl()"
      [class.disabled]="isDisabled"
    >
      +
    </div>
  </div>
</div>
